export interface Action {
  type: string;
  payload?: any;
}

export enum SubscribedProductTypesType {
  SubscribedProductTypeAdded = 'SUBSCRIBED_PRODUCT_TYPE_ADDED',
  SubscribedProductTypesCleared = 'SUBSCRIBED_PRODUCT_TYPES_CLEARED',
}

export enum FeatureFlagsActionType {
  InitializeFeatureFlags = 'INITIALIZE_FEATURE_FLAGS',
}

export enum MainFiltersActionType {
  UpdateMainFilters = 'UPDATE_MAIN_FILTERS',
  UpdateMFPeriod = 'UPDATE_MF_PERIOD',
  UpdateMFPeriodicity = 'UPDATE_MF_PERIODICITY',
  UpdateMFComparisonPeriod = 'UPDATE_MF_COMPARISON_PERIOD',
  UpdateMFCustomMonthsPeriodState = 'UPDATE_MF_CUSTOM_MONTHS_PERIOD_STATE',
  UpdateMFCustomWeeksPeriodState = 'UPDATE_MF_CUSTOM_WEEKS_PERIOD_STATE',
}

export enum MainFiltersTaActionType {
  UpdateMainFiltersTA = 'UPDATE_MAIN_FILTERS_TA',
  UpdateMFTAPeriod = 'UPDATE_MFTA_PERIOD',
  UpdateMFTAPeriodicity = 'UPDATE_MFTA_PERIODICITY',
  UpdateMFTAComparisonPeriod = 'UPDATE_MFTA_COMPARISON_PERIOD',
  UpdateMFTACustomMonthsPeriodState = 'UPDATE_MFTA_CUSTOM_MONTHS_PERIOD_STATE',
  UpdateMFTACustomWeeksPeriodState = 'UPDATE_MFTA_CUSTOM_WEEKS_PERIOD_STATE',
}

export enum MainFilterTypesCL {
  MainFiltersUpdatedCL = 'MAIN_FILTERS_CL_UPDATED',
}

export enum MainFiltersRoActionType {
  UpdateMainFiltersRo = 'UPDATE_MAIN_FILTERS_RO',
  UpdateMFROPeriod = 'UPDATE_MFRO_PERIOD',
  UpdateMFROPeriodicity = 'UPDATE_MFRO_PERIODICITY',
  UpdateMFROComparisonPeriod = 'UPDATE_MFRO_COMPARISON_PERIOD',
  UpdateMFROCustomMonthsPeriodState = 'UPDATE_MFRO_CUSTOM_MONTHS_PERIOD_STATE',
  UpdateMFROCustomWeeksPeriodState = 'UPDATE_MFRO_CUSTOM_WEEKS_PERIOD_STATE',
}

export enum MainFilterTypesMP {
  MainFiltersUpdatedMP = 'MAIN_FILTERS_MR_UPDATED',
  UpdateMFMPGrowthType = 'UPDATE_MFMP_GROWTH_TYPE',
  UpdateMFMPPeriod = 'UPDATE_MFMP_PERIOD',
  UpdateMFMPPeriodicity = 'UPDATE_MFMP_PERIODICITY',
  UpdateMFMPComparisonPeriod = 'UPDATE_MFMP_COMPARISON_PERIOD',
  UpdateMFMPCustomMonthsPeriodState = 'UPDATE_MFMP_CUSTOM_MONTHS_PERIOD_STATE',
  UpdateMFMPCustomWeeksPeriodState = 'UPDATE_MFMP_CUSTOM_WEEKS_PERIOD_STATE',
}

export enum SideFiltersTypes {
  SideFiltersUpdate = 'SIDE_FILTERS_UPDATED',
}

export enum RetailerClientTypes {
  RetailerClientUpdate = 'RETAILER_CLIENT_UPDATED',
}

export enum HitlistsRetailerClientTypes {
  HitlistsRetailerClientUpdate = 'HITLISTS_RETAILER_CLIENT_UPDATED',
}

export enum RetailKadClientTypes {
  RetailKadClientUpdate = 'RETAIL_KAD_CLIENT_UPDATED',
}

export enum MarketPremiumRetailerClientTypes {
  MarketPremiumRetailerClientUpdate = 'MARKET_PREMIUM_RETAILER_CLIENT_UPDATED',
}

export enum InitialFiltersTypes {
  InitialFiltersUpdate = 'INITIAL_FILTERS_UPDATED',
}

export enum MainFilterTypeProducts {
  MainFiltersUpdatedProducts = 'MAIN_FILTERS_PRODUCTS_UPDATED',
}

export enum InitialFiltersProductsTypes {
  InitialFiltersProductsUpdate = 'INITIAL_FILTERS_PRODUCTS_UPDATED',
}

export enum SellerInsightsRetailerClientTypes {
  SellerInsightsRetailerClientUpdate = 'SELLER_INSIGHTS_RETAILER_CLIENT_UPDATED',
}

export enum InitialFiltersMarketPremiumTypes {
  InitialFiltersMarketPremiumUpdate = 'INITIAL_FILTERS_MARKET_PREMIUM_UPDATE',
}

export enum MultiCountryLatestTimeFrameTypes {
  MultiCountryLatestTimeFrameUpdate = 'MULTI_COUNTRY_LATEST_TIME_FRAME_UPDATE',
}
